<template>
  <div class="liu-xuan-test-start-block-2019">
    <chat-left v-for="(item, index) in chatList"
               :key="index"
               :avatar="item.avatar"
               :name="item.name"
               :nick-name="item.nickName"
               :content="item.content"
               :emoji="item.emoji"
               @addShowItemCount="handleAddItemCount"
    />
  </div>
</template>

<script>
  import ChatLeft from '@/pages/2019/LiuXuanTest/components/ChatLeft';

  export default {
    name: 'LiuXuanTestChatLeftBlock2019',
    components: {
      ChatLeft,
    },
    props: {
      list: {
        type: Array,
        required: true,
      },
      status: {
        type: String,
      },
    },
    data() {
      return {
        itemCount: 1,
      };
    },
    computed: {
      chatList() {
        return this.list.filter((item, index) => this.itemCount >= (index + 1));
      },
    },
    methods: {
      handleAddItemCount() {
        this.itemCount += 1;
      },
      handleAddBlockCount() {
        const time = (this.list.length * 1500) + 300;
        setTimeout(() => {
          this.$emit('addShowBlockCount', this.status);
        }, time);
      },
    },
    created() {
      this.handleAddBlockCount();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

</style>
